import { gsap } from 'gsap';
import { init, enter } from '../animations';

export function gameoverEnter(el) {
  const bg = el.querySelector('.ui-game-over__bg');
  const banner = el.querySelector('.ui-game-over__banner');
  const scoreTexts = [...el.querySelectorAll('.app-score p')];
  const share = el.querySelector('.content__share');
  const table = el.querySelector('.content__table');
  const buttonRounded = el.querySelector('.content__button');
  const tl = gsap.timeline();

  init.get('fade')(bg);
  init.get('banner')(banner);
  init.get('fade')(scoreTexts, { y: 20 });
  init.get('buttonRounded')(buttonRounded);

  tl.addLabel('start')
    .add(enter.get('fade')(bg, 0, 0.5), 'start')
    .add(enter.get('banner')(banner), 'start+=0.2')
    .add(enter.get('fade')(scoreTexts, 0.15, 0.5), 'start+=0.45')
    .add(enter.get('buttonRounded')(buttonRounded), table ? 'start+=1.2' : share ? 'start+=1.05' : 'start+=0.7'); // eslint-disable-line

  if (share) {
    const shareText = share.querySelector('.share-button__caption');
    const shareButton = share.querySelector('.share-button__button');

    init.get('buttonCircular')(shareButton);
    init.get('fade')(shareText);

    tl.add(enter.get('fade')(shareText), 'start+=0.7')
      .add(enter.get('buttonCircular')(shareButton), 'start+=0.8');
  }

  if (table) {
    init.get('fade')(table);

    tl.add(enter.get('fade')(table), 'start+=1.05');
  }

  return tl;
}

export function gameoverLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' });

  return tl;
}
